<template>

  <KeyList v-if="ready" :class="css" :componentCss="cssValue()" :key="redraw" :componentName="componentName"
    :showLabel="row.showLabel()" :title="Vehicle.FIELDS.Checklists" :placeholder="row.name()"
    :required="showMissingRequirements" :defaultValue="row.defaultValue()" :options="checklists"
    :mandatory="row.mandatoryValue()" :hint="row.hint()" :showClear="row.showClear()" :hintUrl="row.hintUrl()"
    v-on:value="withValue" />

</template>

<script>

import { mapGetters } from 'vuex'

import MC from "@/domain/session/MC.js";

import ContentUtils from '@/utils/ContentUtils.js';


import KeyList from '@/components/input/KeyList.vue';

import Vehicle from '@/domain/model/vehicle/Vehicle.js';
import Checklist from '@/domain/model/checklist/CheckList.js';
import ChecklistMap from '@/domain/model/checklist/CheckListMap.js';
import ChecklistUpdateRow from "./ChecklistUpdateRow.js";

export default {
  name: 'checklist-update-cell',
  components: {
    KeyList,
    /* ChildCellFactory: () => import("@/portals/shared/cell/CellFactory.vue") */
  },
  props: {
    css: { type: String, default: "" },
    showMissingRequirements: { type: Boolean, default: false },
    data: null,
  },
  data() {
    return {
      redraw: 1,
      ready: false,
      MC: new MC(),
      Contents: ContentUtils,

      row: new ChecklistUpdateRow(),
      checklists: [],
      componentName: "",

      Checklist: Checklist,
      Vehicle: Vehicle,
      ChecklistMap: ChecklistMap,
    };
  },
  watch: {
    showMissingRequirements() {
      window.console.log("showMissingRequirements changed to: " + this.showMissingRequirements);
    }
  },
  computed: {
    ...mapGetters([
      'domain',
    ]),
    rowData: function () {
      return this.data;
    },
  },
  mounted: function () {
    this.row.data = this.data;
    this.componentName = this.row.field();
    var company = this.row.company();
    var all = this.domain.companys().findById(company).checklists();
    var list = all.list();
    for (var i = 0; i < list.length; i++) {
      var checklist = list[i];
      var option = {};
      option["@rid"] = checklist.id();
      option["name"] = checklist.name();
      option["details"] = checklist.description();
      this.checklists.push(option);
    }
    this.ready = true;
  },
  methods: {
    cssValue() {
      return this.row.css();
    },
    withValue: function (kvp) {
      kvp['id'] = this.row.id();
      kvp['object'] = ChecklistMap.MODEL_NAME;
      kvp['field'] = this.row.field();
      kvp['key'] = this.row.key();

      this.$emit('withValue', kvp);
    },
    withButtonPressed: function () {
      var data = {};
      data['id'] = this.row.id();
      data['object'] = ChecklistMap.MODEL_NAME;
      data['field'] = this.row.field();
      data['key'] = this.row.key();
      this.$emit('click', data);
      this.$emit('withButtonPressed', data);
    }
  },
}
</script>
